module.exports = __webpack_public_path__ + "static/media/webshop2023-10-25.f8c2133a.png";